export default __webpack_public_path__ + "static/media/Help_pls_all.d65dee99.pdf";